<app-products-header-banner></app-products-header-banner>

<div class="container w-full mx-auto my-10 px-10 flex flex-col gap-5 md:gap-3 justify-center items-center mt-20">
  <h2 class="font-bold text-3xl website-heading">Varroc Connect Score</h2>
  <span class="font-light text-2xl website-light-heading">Elevate your Driving experience using the Varroc Connect
    Score</span>

  <span class="text-l text-justify w-full mt-5 color-[#0A0A0A]">Our AI-powered Smart Driving Insights analyze your
    driving style (acceleration, braking, etc.), vehicle health (engine performance, fuel efficiency), and even
    environmental factors (traffic, weather, road conditions) to create a personalized Varroc Connect Score. Powered by
    advanced AI and machine learning, this feature transforms your connected vehicle platform into a true driving
    partner, helping you become smarter, more confident, and more responsible on the road</span>

  <!-- Row 1 -->
  <div class="flex gap-6 md:flex-row flex-col mt-5 w-full">
    <div class="flex flex-1 rounded-md store-container-border p-6 shadow-md items-center gap-3">
      <img [src]="Images.ICON_FUEL" alt="Fuel Efficiency Optimization Icon" class="size-8">
      <span>Enhance Efficiency: Maximize fuel economy or battery range (EV) based on real-time factors.</span>
    </div>
    <div class="flex flex-1 rounded-md store-container-border p-6 shadow-md items-center gap-3">
      <img [src]="Images.ICON_STEARING" alt="Steering Icon - Safer Driving Representation" class="size-8">
      <span>Become a Better Driver: Develop smoother, safer, and more efficient driving habits.</span>
    </div>
  </div>

  <!-- Row 2 -->
  <div class="flex gap-6 md:flex-row flex-col mt-5 w-full">
    <div class="flex flex-1 rounded-md store-container-border p-6 shadow-md items-center gap-3">
      <img [src]="Images.ICON_GUAGE" alt="Vehicle Performance Optimization Insights Icon" class="size-8">
      <span>Optimize Your Vehicle: Data-driven insights to maintain your vehicle and maximize its performance.</span>
    </div>
    <div class="flex flex-1 rounded-md store-container-border p-6 shadow-md items-center gap-3">
      <img [src]="Images.ICON_ZOOM" alt="Driving Performance Analysis Algorithm Icon" class="size-8">
      <span>Deliver an enhanced score using our proprietary algorithm that analyzes multiple driving parameters.</span>
    </div>
  </div>

  <div class="flex flex-col mt-10 gap-10  md:mt-20 md:gap-20 items-center justify-center">
    <img [src]="Images.SCORE_9_10" alt="Varroc Connect Expert Score" class="w-1/2">
    <img [src]="Images.SCORE_6_8" alt="Varroc Connect Advanced Score" class="w-1/2">
    <img [src]="Images.SCORE_0_5" alt="Varroc Connect Basic Score" class="w-1/2">
  </div>

</div>